import { useTranslation } from '@mint-lib/i18n';
import { enqueueSnackbar } from '@mint-lib/notifications';
import { useMutation, useQueryClient } from '@mint-lib/query-client';
import { MediaPlan } from '@mint-sdk/api-media-plan';

export const useCreateFlightVersion = () => {
  const { t } = useTranslation('@myn/planning_v2');
  const queryClient = useQueryClient();
  const { mutateAsync: createFlightVersionAsync } =
    MediaPlan.createFlightVersion();

  return useMutation({
    mutationFn: async ({ mediaDataId }: { mediaDataId: string }) =>
      createFlightVersionAsync({ urlParams: { mediaDataId } }),
    onSuccess: () => {
      enqueueSnackbar({
        title: t('New version created'),
        variant: 'success',
        removable: true,
      });
    },
    onSettled: (_data, _err, { mediaDataId }) => {
      const queryKey = MediaPlan.getFlightVersionList({
        urlParams: { mediaDataId },
      }).queryKey;

      queryClient.invalidateQueries({ queryKey });
    },
  });
};
